<template>
  <b-modal id="modal-counting"
           title="Let’s see what we’ve got!"
           :ok-only = "true"
           ok-title = "Stop"
           :lazy="true"
           no-close-on-backdrop
           no-close-on-esc
           no-enforce-focus
           hide-header-close
           body-class="the-modal"
           @ok = "ok"
  >
    <img src="../../assets/images/counting_new.gif" />
    <p>We’re checking to see how many prospects we have based on your selections. Just a few more seconds.</p>
  </b-modal>

</template>

<script>
  import utils from '@/assets/utils/index'

  export default {
    components: {
    },
    created () {
    },
    data () {
      return {
      }
    },
    computed: {
    },
    watch: {
    },
    methods: {
      ok () {
        utils.progressDone()
        this.$store.commit('order/saveKey', ['CurrentStep', 'input'])
      },
      hide () {
        this.$root.$emit('bv::hide::modal', 'modal-counting')
      }
    }
  }
</script>

<style>
.the-modal {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/summary/MCounting.vue